import type { GroupedSmartSurveyorElement } from "components/SmartSurveyor/ReviewPage/types";

interface FindElementGroupLabelArgs {
  groupIds: string[];
  byGroupId: Record<string, GroupedSmartSurveyorElement[]>;
  elementId: string;
}

export const findElementGroupLabel = ({
  groupIds,
  byGroupId,
  elementId,
}: FindElementGroupLabelArgs): string | null => {
  for (const groupId of groupIds) {
    const elements = byGroupId[groupId] ?? [];
    if (elements.some((element) => element.id === elementId)) {
      return groupId;
    }
  }
  return null;
};
